import { IStopsInitialState } from '@types';

export const initialStops = (): IStopsInitialState => {
    return { stopsList: { total: 0, stops: [] }, stop: null };
};
